export default "__VITE_ASSET__gk7awPLY__"